/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for Notification controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, GetNotificationsResponse } from "../models";

@Injectable({ providedIn: "root" })
export class NotificationService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    markNotificationAsRead(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    markNotificationAsRead(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    markNotificationAsRead(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    markNotificationAsRead(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Notification/${id}/Read`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.patch(url, null, requestOptions);
    }

    getNotifications(observe?: 'body', options?: RequestOptions<'json'>): Observable<GetNotificationsResponse>;
    getNotifications(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetNotificationsResponse>>;
    getNotifications(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetNotificationsResponse>>;
    getNotifications(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Notification`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    deleteNotification(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteNotification(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteNotification(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteNotification(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Notification/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.delete(url, requestOptions);
    }
}
